var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("消息内容"),
      maskClosable: false,
      footer: null,
      width: 600,
      wrapClassName: "message-detail-model"
    },
    on: {
      cancel: _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", [_vm._v(" 您还没有回传投保告知书，请先去【投保管理-投保告知书】页面回传投保告知书。如已回传，请忽略。 ")]), _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.close
    }
  }, [_vm._v("知道了")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };